import { cn } from '@/ui/utils/style'

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <span className={cn('block animate-pulse rounded-md bg-foreground/20', className)} {...props} />
}
